import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { ColorSelectorComponent } from './color-selector/color-selector.component';
import { AssigneeSelectorComponent } from './assignee-selector/assignee-selector.component';
import { IconColorSelectorComponent } from './icon-color-selector/icon-color-selector.component';
import { SubtaskAssigneeMenuComponent } from './subtask-assignee-menu/subtask-assignee-menu.component';
import { GlobalModule } from '../../../global/global.module';

@NgModule({
    declarations: [ColorSelectorComponent, AssigneeSelectorComponent, IconColorSelectorComponent, SubtaskAssigneeMenuComponent],
    imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule, TranslateModule, GlobalModule, MatMenuModule],
    exports: [ColorSelectorComponent, AssigneeSelectorComponent, IconColorSelectorComponent, SubtaskAssigneeMenuComponent],
})
export class SharedModule {}
